import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TaskStatus } from 'app/models/Tasks/Tasks';
import { NewChip } from './CustomMultiStatusChip/NewChip';
import { PendingChip } from './CustomMultiStatusChip/PendingChip';
import { CompletedChipGrid } from './CustomMultiStatusChip/CompletedChipGrid';

export const StatusBadgeGrid = ({
  statusId,
}: {
  statusId?: number;
}) => {
  const { t } = useTranslation();
  const displayStatusBadge = useMemo(() => {
    switch (statusId) {
      case TaskStatus.New:
        return <NewChip label={t('notification.taskStatuses.newStatus')}></NewChip>;
      case TaskStatus.Pending:
        return <PendingChip label={t('notification.taskStatuses.pending')}></PendingChip>;
      case TaskStatus.Completed:
        return <CompletedChipGrid label={t('notification.taskStatuses.completedStatus')}></CompletedChipGrid>;
      default:
        return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusId]);

  return displayStatusBadge;
};
